import type { AxiosInstance } from 'axios';
import { internalApiClient } from '@/marketing/infrastructure/http/httpClient';
import type {
  CampaignInfluencerTag,
  CreateCampaignInfluencerTagRequest,
  RenameCampaignInfluencerTagRequest,
} from '@/marketing/models/campaignInfluencerTag';

const BASE_PATH = '/campaignInfluencerTag';

export class CampaignInfluencerTagAPIClient {
  constructor(private readonly client: AxiosInstance = internalApiClient) {}

  public async listTags(campaignId: string): Promise<CampaignInfluencerTag[]> {
    const { data: tags } = await this.client.get<CampaignInfluencerTag[]>(BASE_PATH, { params: { campaignId } });
    return tags;
  }

  public async createTag(createTagRequest: CreateCampaignInfluencerTagRequest): Promise<CampaignInfluencerTag> {
    const { data: createdTag } = await this.client.post<CampaignInfluencerTag>(BASE_PATH, createTagRequest);

    return createdTag;
  }

  public async renameTag(
    tagId: string,
    renameTagRequest: RenameCampaignInfluencerTagRequest,
    campaignId: string,
  ): Promise<CampaignInfluencerTag> {
    const { data: renamedTag } = await this.client.patch<CampaignInfluencerTag>(
      `${BASE_PATH}/${tagId}`,
      renameTagRequest,
      { params: { campaignId } },
    );

    return renamedTag;
  }

  public async deleteTag(tagId: string, campaignId: string): Promise<void> {
    await this.client.delete<void>(`${BASE_PATH}/${tagId}`, { params: { campaignId } });
  }
}

export const campaignInfluencerTagAPIClient = new CampaignInfluencerTagAPIClient();
